import React, { Component } from 'react';

import ButtonGroup from '@mui/material/ButtonGroup';
import { WithStyles, withStyles } from '@mui/styles';

import APSegmentedControlOption from './APSegmentedControlOption';

import APSegmentedControlStyles from './styles/APSegmentedControl.style';

interface APSegmentedControlProps extends WithStyles<typeof APSegmentedControlStyles> {
  onChange?: Function,
  options: any,
  selection?: any
}

class APSegmentedControl extends Component<APSegmentedControlProps, {}> {
  constructor(props: APSegmentedControlProps) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(value: any) {
    const {
      onChange
    } = this.props;

    if (onChange) {
      onChange(value);
    }
  }

  render() {
    const {
      classes,
      options,
      selection
    } = this.props;

    return (
      <div className={classes.segmentedControl}>
        <ButtonGroup>
          {options.map((option: any) => (
            <APSegmentedControlOption
              onClick={this.onClick}
              disabled={option.disabled}
              selected={option.value === selection}
              value={option.value}
            >
              {option.label}
            </APSegmentedControlOption>
          ))}
        </ButtonGroup>
      </div>
    );
  }
}

export default withStyles(
  APSegmentedControlStyles
)(APSegmentedControl) ;
